import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { DataTableColumnText } from './data-table-column-text.config';

@Component({
  selector: 'data-table-column-text',
  imports: [NgClass],
  templateUrl: './data-table-column-text.component.html',
  styleUrl: './data-table-column-text.component.scss'
})
export class DataTableColumnTextComponent {

  @Input() column!: DataTableColumnText;
  @Input() item!: any;

}
